import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Grid, TablePagination, Typography } from "@mui/material";
import { dateFormate } from "utils/utils";
import pick from "assets/images/pickUp.svg";
import drop from "assets/images/drop.svg";

function MyRideCard(props) {
  const navigate = useNavigate();
  const  tripData  = props?.tripData;
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get('type')
  const handleChange = (event,data) =>{
  navigate(`/myride/details?type=${type || "All"}`,{state:{id:data?.id}})
}
const handleChangePage = (event, newPage) => {
  props.handleChangePage(event, newPage);
};

const handleChangeRowsPerPage = (event) => {
  props?.handleChangeRowsPerPage(event);
};
  return (
    <Grid container md={12}>
     {tripData && tripData?.map((trip) => 
      <Grid
        item
        direction="column"
        justifyContent="space-evenly"
        alignItems="center"
        className="boxShadowBlack padding20"
        md={12}
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="paddingBlock10"
          md={12}
        >
          <Typography className="colorBlue">{dateFormate(trip?.scheduledTime,'DD MMM YYYY, hh:mm a')}</Typography>
          <Typography 
          className={`fontSemi 
          ${trip?.status === 'Completed'?
           'colorGreen'
           :
           trip?.status === 'Cancelled' ? 
           'colorRed' 
            : 
            trip?.status === 'onGoing'?
            'colorGrey'
            :
            trip?.status === 'Booked'?
            'colorBlue'
            :
            trip?.status === 'Accepted'?
            'colorYellow':null
            
            } `}>{trip?.status} </Typography>
        </Grid>
        <Grid
          item
          container
          direction="column"
          justifyContent="space-between"
          className="paddingBlock10"
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            className="marginBottom7"
          >
            <Grid item md={0.5} xs={1} className="pickUpItem">
              <img src={pick} alt="star" className="pickUpPosition" />
            </Grid>
            <Grid item md={11.5} xs={10}>
              <Typography className="font16 fontNormal">
                {trip?.sourceAddress}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid item md={0.5} xs={1}>
              <div className="dropImg">
                <img src={drop} alt="star" />
              </div>
            </Grid>
            <Grid item md={11.5} xs={10}>
              <Typography className="font16 fontNormal">
              {trip?.destinationAddress}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid className="dashedTopLine1px"> <Typography>{trip?.tripType}</Typography></Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          className="paddingBlock10"
        >    
          <Typography className="">{trip?.MasterCarType?.carType}{", "}{trip?.MasterCarType?.seater}{" Seater"}</Typography>
          <Button
          className="greyButton" onClick={(event) =>handleChange(event,trip)}>View Details </Button>
        </Grid>
      </Grid>
      )}
      {
        props?.totalCount > 10 && 
        (<Grid item
        md={8}>

           <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={props?.totalCount}
            rowsPerPage={props?.rowsPerPage}
            page={props?.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          
          />
          </Grid>
       )} 
    </Grid>
  );
}

export default MyRideCard;
